<template>
  <div
    class="atom-back atom-back--gray"
    :class="{ 'atom-back--white': white, 'atom-back--black': black }"
    @click="goBack()"
  >
    <div class="atom-back__inner d-flex align-items-center">
      <img src="@/assets/icons/arrows/arr-gray-left.svg" /><span>{{
        $t(text)
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["text", "route", "white", "black"],
  methods: {
    goBack() {
      if (this.route) {
        this.$router.push(this.route);
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
